import Button from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal';
import Select from '@/components/Select/Select';
import { fetchPartners, postGamesAttachPartner } from '@/lib/api';
import { styled } from '@mui/material/styles';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SaveIcon from '@/assets/save-floppy-disk.svg?react';
import useInfiniteScroll from '@/hooks/useInfiniteScroll';
import { PartnerSchema } from '@/lib/types';
import { AxiosResponse } from 'axios';

const AddPartnerModal = ({
  gameId,
  open,
  onClose,
  onSave,
}: {
  gameId: number;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { data: dataPartners } = useInfiniteScroll<PartnerSchema>({
    fetchFn: fetchPartners,
    queryKey: ['games', { type: ['brand'] }],
    params: { type: ['brand'] },
    scrollContainerRef:
      scrollContainerRef as React.RefObject<HTMLElement>,
    pageSize: 10,
    scrollThreshold: 100,
    enabled: open && dropdownOpen,
  });
  const [selectedPartners, setSelectedPartners] = useState<number[]>(
    [],
  );
  const partnerItems = dataPartners?.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.id,
    text: item.name,
  }));

  const handleSave = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const promises: Promise<AxiosResponse<PartnerSchema, any>>[] = [];
    selectedPartners.forEach((partnerId) => {
      promises.push(postGamesAttachPartner(gameId, partnerId));
    });
    Promise.all(promises).then(() => {
      onSave();
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Partner"
      actions={[
        <Button
          key="close"
          variant="text"
          onClick={onClose}
          aria-label="Cancel Button"
        >
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </Button>,
        <Button
          key="save"
          variant="contained"
          onClick={handleSave}
          aria-label="Save Button"
        >
          <SaveIcon />
          <FormattedMessage id="save" defaultMessage="Save" />
        </Button>,
      ]}
    >
      <Label>
        <FormattedMessage
          id="selectMarkets"
          defaultMessage="Select Partners you would like to add"
        />
      </Label>
      <Select
        ref={scrollContainerRef}
        multiple
        placeholder={
          <FormattedMessage id="select" defaultMessage="Select" />
        }
        options={partnerItems}
        value={selectedPartners}
        onChange={(v) => setSelectedPartners(v as number[])}
        variant="outlined"
        searchEnabled
        size="small"
        onDropdownToggle={setDropdownOpen}
      />
    </Modal>
  );
};

const Label = styled('div')<{ topMargin?: boolean }>(
  ({ theme, topMargin = false }) => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    marginBottom: theme.spacing(1),
    marginTop: topMargin ? theme.spacing(4) : 0,
  }),
);

export default AddPartnerModal;
